import { WRRST_FLG } from '../../constants/seo';
import { adaptUrl } from '../../utils/seoUtil';
import { Dto } from './createSeoText';

const tmst276s = [
  {
    WURLID: '1',
    WURL: 'DodaFront/View/JobSearchList/*',
    WTXT: 'null',
    WRRSTFL: '2',
    WBTDT: '12-03-22 00:00:00',
    WCRDT: '12-03-22 10:29:03',
    WCRID: 'BJSEO0133',
    WUPDT: '',
    WUPID: '""',
    WDLDT: '',
    WDLID: '""',
    WDLFL: '0',
  },
  {
    WURLID: '2',
    WURL: 'engineer/View/ENJobSearchList/*',
    WTXT: 'null',
    WRRSTFL: '2',
    WBTDT: '12-03-22 00:00:00',
    WCRDT: '12-03-22 10:29:03',
    WCRID: 'BJSEO0133',
    WUPDT: '14-09-04 04:28:37',
    WUPID: 'IBS0103_01',
    WDLDT: '14-09-04 04:28:37',
    WDLID: 'IBS0103_01',
    WDLFL: '9',
  },
  {
    WURLID: '6',
    WURL: 'DodaFront/View/CareerRecommendJobList/*',
    WTXT: '""',
    WRRSTFL: '2',
    WBTDT: '21-09-29 00:00:00',
    WCRDT: '21-09-29 11:11:36',
    WCRID: 'T0813238_1',
    WUPDT: '21-09-29 11:11:36',
    WUPID: 'T0813238_1',
    WDLDT: '',
    WDLID: '""',
    WDLFL: '0',
  },
];
const listWurl = tmst276s.map((item) => item.WURL);

/**
 * SEOテキスト取得処理
 * @param {string} path urlのpath
 * @param {Dto} dto SEOテキスト
 * @param defaultSeoText
 * @returns SEOテキスト
 */
export const getSeoText = (defaultSeoText: Dto): Dto => {
  // 画面側のURL
  // const staticUrl = makeStaticUrl(query, path);
  // 仮値
  const staticUrl = 'DodaFront/View/JobSearchList/';
  // テキスト文設定マスタデータを取得
  const rec = adaptUrl(staticUrl, listWurl);
  let returnSeoText: Dto = {
    titleOrText: '',
    text: '',
    areaText: '',
    careerExplainText: '',
    defaultFlg: false,
  };
  if (rec !== null) {
    // 該当するURLが存在する場合

    // テキスト文設定マスタのURLと照合処理
    const tmst276 = tmst276s[rec];

    // ルール設定フラグ
    if (String(WRRST_FLG) === tmst276.WRRSTFL) {
      // テキスト
      returnSeoText.titleOrText = tmst276.WTXT;
    } else {
      returnSeoText = defaultSeoText;
    }
    return returnSeoText;
  }
  // 該当するURLが存在しない場合、デフォルト値を表示する。
  // TODO:プロパティファイルから取得
  return returnSeoText;
};
